import { motion } from 'framer-motion';

const ease = [0.25, 0.46, 0.45, 0.94];

const variants = {
  up:    { hidden: { opacity: 0, y: 28 },    visible: { opacity: 1, y: 0 } },
  down:  { hidden: { opacity: 0, y: -20 },   visible: { opacity: 1, y: 0 } },
  left:  { hidden: { opacity: 0, x: -28 },   visible: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 28 },    visible: { opacity: 1, x: 0 } },
  fade:  { hidden: { opacity: 0 },           visible: { opacity: 1 } },
  scale: { hidden: { opacity: 0, scale: 0.96 }, visible: { opacity: 1, scale: 1 } },
};

/**
 * Wrap any element to reveal it when it enters the viewport.
 * direction: 'up' | 'down' | 'left' | 'right' | 'fade' | 'scale'
 */
const ScrollReveal = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.55,
  className = '',
  once = true,
}) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once, margin: '-60px' }}
    variants={variants[direction]}
    transition={{ duration, delay, ease }}
    className={className}
  >
    {children}
  </motion.div>
);

/**
 * Stagger children with ScrollReveal applied to each.
 */
export const StaggerReveal = ({ children, stagger = 0.08, className = '' }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '-60px' }}
    variants={{ visible: { transition: { staggerChildren: stagger } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, direction = 'up', className = '' }) => (
  <motion.div variants={variants[direction]} className={className}>
    {children}
  </motion.div>
);

export default ScrollReveal;
